import GoodPracticeDetails from "./components/GoodPracticeDetails";

export default GoodPracticeDetails;